import { toast } from "react-hot-toast";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { showMutationError } from "utils/showMutationError";

export const useDeleteImmunisation = () => {
  const queryClient = useQueryClient();

  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useMutation({
    meta: { skipGlobalError: true },
    onError: (error) => showMutationError(error),
    mutationFn: async (id) => {
      const axiosInstance = createAxiosInstance();
      await axiosInstance.delete(`${tenantVal}/patientimmunisation/delete`, {
        data: { id },
      });
    },
    onSuccess: () => {
      toast.success("Vaccine has been deleted.");
      queryClient.invalidateQueries({ queryKey: ["vaccines"] });
      queryClient.invalidateQueries({ queryKey: ["allImmunisations"] });
      queryClient.invalidateQueries({ queryKey: ["healthlinkImmunisations"] });
      queryClient.invalidateQueries({ queryKey: ["healthlinkVaccines"] });
    },
  });
};
